import { AnnouncementSchema, type Announcement } from '../types';

/** Lancement Outlook : catalogue partagé par la modale login et les notifications. */
export const outlookAnnouncement: Announcement = AnnouncementSchema.parse({
  id: '2026-10-12-hector-outlook',
  date: '2026-10-13',
  layout: 'spotlight',
  kicker: 'Nouveau complément',
  title: 'Hector arrive dans Outlook',
  navLabel: 'Hector dans Outlook',
  subtitle: '',
  intro: [
    'Retrouvez **Hector directement dans Outlook**, à côté du courriel que vous consultez. Demandez-lui de le résumer, de préparer une réponse ou de ranger le message et ses pièces jointes dans votre dossier.',
    'Vous pouvez aussi **connecter votre boîte Microsoft** pour lui permettre de rechercher les courriels utiles à vos demandes, au-delà du message affiché. Cette connexion est facultative : vous pouvez la faire plus tard.',
    'Hector prépare des brouillons : **vous gardez la main sur leur envoi**.',
  ],
  introCallout: {
    text: 'Installez le complément depuis Microsoft Marketplace. Après l’installation, le complément peut prendre 24 à 48 heures avant d’apparaître dans Outlook.',
    cta: {
      label: 'Télécharger le complément Outlook',
      url: 'https://marketplace.microsoft.com/fr-fr/product/WA200012500',
    },
  },
  videoCaption: 'Découvrez Hector pour Outlook dans la vidéo ci-dessous',
  video: { provider: 'youtube', id: 'ReE1AKz8zpg' },
  footer: {
    text: 'Retrouvez cette présentation dans la section Aide.',
    cta: {
      label: 'Découvrir Hector pour Outlook',
      url: 'https://www.app.hector.legal/aide/hector-outlook',
    },
  },
  sections: [],
});
